import React, { useState, useEffect, useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './PublicHeader.css';
import { LandingContext } from '../../Components/Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';

const PublicHeader = () => {
    // A data-driven approach is cleaner and easier to maintain
    const navLinks = [
        { path: "/about-company", icon: "ri-building-line", label: "About Company" },
        { path: "/our-services", icon: "ri-customer-service-2-line", label: "Our Services" },
        { path: "/about-agents", icon: "ri-group-line", label: "Agents" },
        { path: "/about-careers", icon: "ri-briefcase-line", label: "Careers" },
        { path: "/about-contact", icon: "ri-phone-line", label: "Contact Us" }
    ];
    const landingData = useContext(LandingContext);
    const headerStyles = {
        '--theme-primary-color': DefaultData.THEMECOLOR1,
        '--theme-secondary-color': DefaultData.THEMECOLOR2,
    };

    return (
        <header className="b2b-public-header" style={headerStyles}>
            <div className="container-fluid">
                <div className="navbar-content">
                    <div className="navbar-logo">
                        <Link to="/" className="logo-link">
                            <img src="/assets/images/logo.png" alt="Company Logo2" width={"150px"} height={"150px"} />
                        </Link>
                    </div>

                    <nav className="navbar-links">
                        {navLinks.map(link => (
                            <NavLink
                                key={link.path}
                                to={link.path}
                                className="nav-link-item"
                            >
                                <i className={link.icon}></i>
                                <span>{link.label}</span>
                            </NavLink>
                        ))}
                    </nav>

                    <div className="navbar-actions">
                        <Link to="/agentregister" className="btn btn-get-started">
                            Get Started
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default PublicHeader;